module.exports = __webpack_public_path__ + "img/mobile/PromoHistory/Promo_Spin_Icon@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/PromoHistory/Promo_Spin_Icon@1x.png
// module id = 118
// module chunks = 0